import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=3caa6fdb&scoped=true"
import script from "./Queue.vue?vue&type=script&lang=ts"
export * from "./Queue.vue?vue&type=script&lang=ts"
import style0 from "./Queue.vue?vue&type=style&index=0&id=3caa6fdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caa6fdb",
  null
  
)

export default component.exports